import { Suspense } from 'react'
import Loading from "@/components/shared/Loading";
import PageContainer from "@/components/template/PageContainer";


const AdminAreaProtectedPageContainer = (p:{children: React.ReactNode}) => {

    return <Suspense
      fallback={
          <div className="flex flex-auto flex-col h-[100vh]">
              <Loading loading={true} />
          </div>
      }
    >
        <PageContainer {...p}>{p.children}</PageContainer>
    </Suspense>

}

export default AdminAreaProtectedPageContainer
